<ng-container [ngSwitch]="ctx.ShopModuleMenu.MenuComponent">
    <app-side-menu-default [ctx]="ctx" *ngSwitchDefault></app-side-menu-default>
    <app-side-menu-doetam [ctx]="ctx" *ngSwitchCase="'doetam'"></app-side-menu-doetam>
</ng-container>